export const LOADING_USER = "loadingUser";
export const ERRORS_USER = "errorsUser";
export const LOADING_MACHINE = "loadingMachine";
export const ERRORS_MACHINE = "errorsMachine";
export const LOADING_PROCESS = "loadingProcess";
export const ERRORS_PROCESS = "errorsProcess";
export const LOADING_MACHINES = "loadingMachines";
export const ERRORS_MACHINES = "errorsMachines";
